import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (devId, key, config) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_DEV_CONFIG',
    method: 'PUT',
    data: config,
  });

  useEffect(() => {
    if (devId && key) {
      let url = `/api/v1/devices/${devId}/configs/${key}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devId, key]);

  return { data, isRequestSuccessed };
}
